import { Reducer } from 'redux';

import { ActionTypes } from '../types/action-types';
import { ActionObject, IApp } from '../types/app';

export default ((state = {}, action: ActionObject): IApp => {
  switch (action.type) {
    case ActionTypes.CHANGE_ME:
      return {
        ...state,
      };
  }
  return {...state};
}) as Reducer<IApp>;



// WEBPACK FOOTER //
// ./src/reducers/app.ts